// extracted by mini-css-extract-plugin
module.exports = {"main":"EmailPage_main__2L9i1","container":"EmailPage_container__9vVdc","mailContainer":"EmailPage_mailContainer__2jU7W"};